export function renderTemplate(template, scope = {}) {
  const parser = new DOMParser();
  const renderedTemplate = template(scope);
  const parsedTemplate = parser.parseFromString(renderedTemplate, 'text/html');

  return parsedTemplate.body.firstElementChild;
}



// WEBPACK FOOTER //
// ./src/scripts/utilities.js